export const postureGraphTest = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (desyncdata !== undefined) {
		if (desyncdata.indexOf('Posture graph threw an exception') !== -1 || desyncdata.indexOf('AssertionError: Source spec not in the posture graph') !== -1) {
      var extraInfo = ''

      if (desyncdata.indexOf('Cannot pick up an object') !== -1) {
        extraInfo = '<br/><br/>This specific error was caused by not being able to access an object to pick up. Perhaps positioning of objects at the lot is causing problems with Sims pathing.'
      } else {
        extraInfo = '<br/><br/>These errors are only caused by not being able to access an object that changes Sims posture when interacting with - like seats, tables, beds, showers, toilets, pools etc. Perhaps positioning of objects at the lot is causing problems with Sims pathing.'
      }

      return {
        type: 'animationStatesTraverseTest',
        color: 'Goldenrod',
        title: 'Posture Graph Error',
        text: 'Base game or Modification issue with the animations system.',
        description: 'A Sim failed to generate path connectivity required to adjust posture for a task to perform. ' + extraInfo +
        '<br/><br/>If this error doesn\'t stop occurring, look into recently placed custom objects and remove them. Otherwise you\'re safe to ignore this error.'
      }
    }
  }
}

// EXAMPLE
/*
<root>
    <report>
        <version>2</version>
        <sessionid>13390c3f2a0d7dfa5b60c63d</sessionid>
        <type>desync</type>
        <sku>ea.maxis.sims4_64.15.pc</sku>
        <createtime>2099-07-31 23:29:13</createtime>
        <buildsignature>Local.Unknown.Unknown.1.99.62.1020-1.200.000.360.Release</buildsignature>
        <categoryid>posture_graph.py:4179</categoryid>
        <desyncid>13390c3f2a0d7dfa5b60c63d</desyncid>
        <systemconfig/>
        <screenshot/>
        <desyncdata>[rez] Posture graph threw an exception while being queried by autonomy: (ValueError: Cannot pick up an object: Book_Write_Genres_NonFiction:0x0ed307db3b18081c from an invalid surface: object_TableEnd:0x075707da0aa3053e)
Traceback (most recent call last):
Caught and logged:
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\utils.py&quot;, line 179, in wrapper
  File &quot;T:\InGame\Gameplay\Scripts\Server\areaserver.py&quot;, line 205, in c_api_server_tick
  File &quot;T:\InGame\Gameplay\Scripts\Server\zone.py&quot;, line 464, in update
  File &quot;T:\InGame\Gameplay\Scripts\Server\time_service.py&quot;, line 112, in update
  File &quot;T:\InGame\Gameplay\Scripts\Server\scheduling.py&quot;, line 217, in simulate
  File &quot;T:\InGame\Gameplay\Scripts\Server\elements.py&quot;, line 385, in _resume
  File &quot;T:\InGame\Gameplay\Scripts\Server\autonomy\autonomy_service.py&quot;, line 496, in _process_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\autonomy\autonomy_service.py&quot;, line 433, in _update_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\autonomy\autonomy_modes.py&quot;, line 251, in run_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\autonomy\autonomy_modes.py&quot;, line 1386, in _run_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\autonomy\autonomy_modes.py&quot;, line 1827, in _score_object_interactions_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\autonomy\autonomy_modes.py&quot;, line 1918, in _create_and_score_interaction
  File &quot;T:\InGame\Gameplay\Scripts\Core\caches.py&quot;, line 144, in wrapper
KeyError: (ConstraintSet(...), _TunableAffordanceFilterWrapper._filter, False, &lt;sim '' 0x57307cc53ab1cf8&gt;, frozenset({&lt;sim '' 0x57307cc53ab1cf8&gt;}), frozenset({(&lt;SI Bed_Undercovers_Cry id:155 sim:&gt;, &lt;bound method Bed_Undercovers_Cry.is_guaranteed of &lt;SI Bed_Undercovers_Cry id:155 sim:&gt;&gt;), (&lt;SI generic_BedUndercovers id:171 sim:&gt;, &lt;bound method generic_BedUndercovers.is_guaranteed of &lt;SI generic_BedUndercovers id:171 sim:&gt;&gt;)}))

During handling of the above exception, another exception occurred:

Traceback (most recent call last):
  File &quot;T:\InGame\Gameplay\Scripts\Server\autonomy\autonomy_modes.py&quot;, line 1915, in _create_and_score_interaction
  File &quot;T:\InGame\Gameplay\Scripts\Server\autonomy\autonomy_modes.py&quot;, line 1028, in _calculate_route_time_and_opportunity
  File &quot;T:\InGame\Gameplay\Scripts\Core\caches.py&quot;, line 156, in wrapper
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\super_interaction.py&quot;, line 2438, in estimate_distance
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\super_interaction.py&quot;, line 2478, in _estimate_distance
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\super_interaction.py&quot;, line 2357, in _generate_connectivity
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\transition_sequence.py&quot;, line 1457, in compute_transition_connectivity
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\transition_sequence.py&quot;, line 1504, in run_transitions
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\transition_sequence.py&quot;, line 3348, in _build_transitions
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\transition_sequence.py&quot;, line 3139, in _build_and_log_transitions_for_sim
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\transition_sequence.py&quot;, line 3201, in _build_transitions_for_sim
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\transition_sequence.py&quot;, line 2679, in get_transitions_for_sim
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\transition_sequence.py&quot;, line 2857, in _get_transitions_for_sim
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\posture_graph.py&quot;, line 5682, in generate_connectivity_handles
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\posture_graph.py&quot;, line 5534, in _get_segmented_path_connectivity_handles
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\posture_graph.py&quot;, line 561, in generate_middle_paths
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\posture_graph.py&quot;, line 4179, in _middle_path_gen
ValueError: Cannot pick up an object: Book_Write_Genres_NonFiction:0x0ed307db3b18081c from an invalid surface: object_TableEnd:0x075707da0aa3053e
</desyncdata>
    </report>
</root>
*/


// WEBPACK FOOTER //
// ./src/tests/basegame/postureGraphTest.js